export enum MenuItemsName {
  SEARCH = 'Search',
  REPORT = 'Report',
  REQUEST = 'Record request',
  CONTACT = 'Contact support',
  HELP = 'Help',
  ADMIN = 'Administration'
}

export enum SubMenuItems {
  ADD_RECORD = 'Add record',
  FEEDBACK = 'Feedback',
  EMAIL = 'Email management'
}

export enum MenuItemsLink {
  REQUEST = 'mailto:CMX_Support@helixops.ai?subject=Request a record',
  CONTACT = 'mailto:CMX_Support@helixops.ai?subject=Support request',
  HELP = 'https://docs.helixops.ai/docs/display/compatibility/Adding+and+editing+compatibility+and+prerequisite+information+with+CMX+Admin',
}
